import React from "react";
import { Box, Paper, Skeleton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { WHITE, IRIS_60 } from "../../colors";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const CustomPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  paddingTop: 15,
  paddingBottom: 10,
  paddingLeft: 15,
  height: 380,
  paddingRight: 15,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  borderRadius: 10,
  minWidth: 250,
}));

export default function GenderDistrib(props) {
  const state0 = props.people?.filter((c) => c.status === 0).length;
  const state1 = props.people?.filter((c) => c.status === 1).length;
  const state2 = props.people?.filter((c) => c.status === 2).length;
  const state3 = props.people?.filter((c) => c.status === 3).length;
  const state4 = props.people?.filter((c) => c.status === 4).length;
  const state5 = props.people?.filter((c) => c.status === 5).length;
  const state6 = props.people?.filter((c) => c.status === 6).length;

  const data = {
    labels: [
      "No Uploads",
      "Stat1",
      "Stat2",
      "Stat3",
      "Stat4",
      "Stat5",
      "Stat6",
    ],
    datasets: [
      {
        label: "# of Votes",
        data: [state0, state1, state2, state3, state4, state5, state6],
        backgroundColor: [
          "#ff0000",
          "#2CDDC7",
          "#849AA9",
          "#598811",
          "#ffDDC7",
          "#840A11",
          "#11ff11",
        ],
        borderColor: [
          "#ff0000",
          "#2CDDC7",
          "#849AA9",
          "#598811",
          "#ffDDC7",
          "#840A11",
          "#11ff11",
        ],
        borderWidth: 1,
      },
    ],
  };
  return (
    <CustomPaper>
      <Typography fontSize={18} color={IRIS_60} style={{ marginLeft: 25 }}>
        Customer by status
      </Typography>

      {props?.people && <Doughnut data={data} />}
      {!props?.people && (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Skeleton variant="rectangular" width={320} height={330} />
        </Box>
      )}
    </CustomPaper>
  );
}
